import {useContext} from "react";
import {useTranslation} from "react-i18next";
import {faArrowUpRight, faEnvelope, faHeadphones, faPhone, faTurntable} from "@fortawesome/pro-solid-svg-icons";

import {Styled} from "./Studio.styles";
import {Editorial} from "../../Styles/editorial";
import ActionButton from "../../lib/UIBookBrd/ActionButton";
import Reveal from "../../lib/UIBookBrd/Reveal";
import {Contact__Values} from "../../PageValues";
import {Local_Data} from "../../Context";

const DEFAULT_STUDIO_IMAGE = 'https://firebasestorage.googleapis.com/v0/b/studioskar.appspot.com/o/Screenshot%202023-11-22%20at%2014.02.59.png?alt=media&token=4c874c1a-2f73-4926-bb06-7bb6121d85a4'

const GEAR_KEYS = ['lbl_studio_gear_1', 'lbl_studio_gear_2', 'lbl_studio_gear_3', 'lbl_studio_gear_4']

const Studio = () => {

    const {t} = useTranslation()

    const [localData] = useContext<any>(Local_Data)

    const studioImage = localData?.studioPageImage ?? DEFAULT_STUDIO_IMAGE

    const mailHref = `mailto:${Contact__Values.emailAddress}?subject=${encodeURIComponent(t('lbl_reserve_spot'))}`

    return (
        <Editorial.Page>
            <Styled.Hero>
                <Styled.HeroText>
                    <Editorial.Eyebrow>{t('lbl_studio_eyebrow')}</Editorial.Eyebrow>
                    <Styled.HeroTitle>{t('lbl_welcome_to_our_studio')}</Styled.HeroTitle>
                    <Editorial.Lead>{t('lbl_studio_first_line')}</Editorial.Lead>
                    <Editorial.Body>{t('lbl_studio_second_line')}</Editorial.Body>
                    <Editorial.ChipRow>
                        {GEAR_KEYS.map((key) => (
                            <Editorial.Chip key={key}>
                                <Editorial.ChipIcon icon={faTurntable}/>
                                {t(key)}
                            </Editorial.Chip>
                        ))}
                    </Editorial.ChipRow>
                    <Editorial.CtaActions style={{marginLeft: 0, marginTop: '6px'}}>
                        <ActionButton
                            size={'lg'}
                            icon={faEnvelope}
                            label={t('lbl_reserve_spot')}
                            onClick={() => {
                                window.location.href = mailHref
                            }}
                        />
                        <ActionButton
                            size={'lg'}
                            variant={'outline'}
                            icon={faPhone}
                            label={Contact__Values.phoneNumbers[0]}
                            onClick={() => {
                                window.location.href = `tel:${Contact__Values.phoneNumbers[0].replace(/\s/g, '')}`
                            }}
                        />
                    </Editorial.CtaActions>
                </Styled.HeroText>

                <Reveal>
                    <Styled.HeroImageFrame>
                        <Styled.HeroImage
                            src={studioImage}
                            alt={t('lbl_welcome_to_our_studio')}
                        />
                    </Styled.HeroImageFrame>
                </Reveal>
            </Styled.Hero>

            <Editorial.Section>
                <Editorial.SectionTitle>{t('lbl_pricing')}</Editorial.SectionTitle>
                <Editorial.CardGrid style={{marginTop: '24px'}}>
                    <Reveal index={0}>
                        <Styled.PriceCard>
                            <Styled.PriceKicker>{t('lbl_studio_price_standard')}</Styled.PriceKicker>
                            <Styled.PriceValue>{t('lbl_studio_pricing')}</Styled.PriceValue>
                        </Styled.PriceCard>
                    </Reveal>
                    <Reveal index={1}>
                        <Styled.PriceCard>
                            <Styled.PriceKicker>{t('lbl_b2b_dj')}</Styled.PriceKicker>
                            <Styled.PriceValue>{t('lbl_studio_pricing_b2b')}</Styled.PriceValue>
                        </Styled.PriceCard>
                    </Reveal>
                </Editorial.CardGrid>

                <Editorial.CardGrid style={{marginTop: '20px'}}>
                    <Reveal index={0}>
                        <Editorial.Card>
                            <Editorial.CardIcon icon={faHeadphones}/>
                            <Editorial.CardTitle>{t('lbl_studio_extras')}</Editorial.CardTitle>
                            <Editorial.CardText>{t('lbl_studio_fourth_line')}</Editorial.CardText>
                        </Editorial.Card>
                    </Reveal>
                    <Reveal index={1}>
                        <Editorial.Card>
                            <Editorial.CardIcon icon={faTurntable}/>
                            <Editorial.CardTitle>{t('lbl_studio_recording')}</Editorial.CardTitle>
                            <Editorial.CardText>{t('lbl_studio_fifth_line')}</Editorial.CardText>
                        </Editorial.Card>
                    </Reveal>
                </Editorial.CardGrid>
            </Editorial.Section>

            <Editorial.Section>
                <Editorial.CtaPanel>
                    <Editorial.CtaText>
                        <Editorial.Eyebrow>{t('lbl_contact')}</Editorial.Eyebrow>
                        <Editorial.SectionTitle>{t('lbl_studio_cta_title')}</Editorial.SectionTitle>
                        <Editorial.Lead>
                            {t('lbl_studio_third_line')}
                            <Editorial.InlineLink
                                href={Contact__Values.instagram}
                                target={'_blank'}
                                rel={'noreferrer'}
                            >
                                {' Instagram '}
                            </Editorial.InlineLink>
                            {` ${t('lbl_or')} `}
                            <Editorial.InlineLink href={`mailto:${Contact__Values.emailAddress}`}>
                                {Contact__Values.emailAddress}
                            </Editorial.InlineLink>
                        </Editorial.Lead>
                    </Editorial.CtaText>
                    <Editorial.CtaActions>
                        <ActionButton
                            size={'lg'}
                            iconRight={faArrowUpRight}
                            label={t('lbl_reserve_spot')}
                            onClick={() => {
                                window.location.href = mailHref
                            }}
                        />
                    </Editorial.CtaActions>
                </Editorial.CtaPanel>
            </Editorial.Section>
        </Editorial.Page>
    )
}

export default Studio
